import { queryClient } from '@/queries/QueryClientProvider'
import { QUERY_KEYS } from '@/queries/queryKeys'
import {
  notificationsService,
  type GetAllNotificationsResponse,
} from '@/services/api/notifications.service'
import {
  type CreateNotificationProps,
  type NotificationSource,
} from '@/services/types/notifications/mockNotifications'
import { useMutation } from '@tanstack/react-query'

async function createNotification<T extends NotificationSource>(data: CreateNotificationProps<T>) {
  const response = await notificationsService.create(data)
  return response.data
}

export function useCreateNotification<T extends NotificationSource>(notificationSource?: T) {
  return useMutation({
    mutationFn: createNotification<T>,
    onSuccess: (data) => {
      const notificationsCachedData = queryClient.getQueryData<GetAllNotificationsResponse<T>>([
        QUERY_KEYS.reviewNotifications.getAll,
        notificationSource,
      ])

      if (!notificationsCachedData) return

      queryClient.setQueryData<GetAllNotificationsResponse<T>>(
        [QUERY_KEYS.reviewNotifications.getAll, notificationSource],
        (oldData) => {
          if (oldData) {
            return {
              notifications: oldData.notifications.concat(data.notification),
              totalNotifications: oldData.totalNotifications,
            }
          }
        },
      )
    },
  })
}
